import { MediaManagerApiBase } from '../MediaManagerApiBase';
export class SdkApi extends MediaManagerApiBase {
  constructor(mediaManagerSDK) {
    super();
    this.mediaManagerSDK = mediaManagerSDK;
  }
  async listItems(folderId, params) {
    const {
      data,
      paging
    } = await this.mediaManagerSDK.listItemsMP(folderId, params);
    return {
      data,
      paging
    };
  }
  async listFolders(folderId, params) {
    const {
      data,
      paging
    } = await this.mediaManagerSDK.listFoldersMP(folderId, params);
    return {
      data: data ?? [],
      paging
    };
  }
  async privateItemInfo(fileId) {
    const result = await this.mediaManagerSDK.privateItemInfoMP(fileId);
    return {
      data: result == null ? void 0 : result.data
    };
  }
  async searchItems(folderId, searchQuery, params) {
    const {
      data,
      paging
    } = await this.mediaManagerSDK.searchItemsMP(folderId, searchQuery, params);
    return {
      data,
      paging
    };
  }
}
//# sourceMappingURL=SdkApi.js.map